import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfirmService } from '../../../modules_v2/shared/services/confirm.service';

@Injectable()
export class DialogsService {

    constructor(private confirmService: ConfirmService) { }

    public confirm(title: string, message: string): Observable<boolean> {
        return this.confirmService.open({
            title,
            message,
            tone: 'info',
            confirmText: 'Aceptar',
            confirmIcon: 'check',
        });
    }
}
